/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FleetSyncItemsResponse } from './FleetSyncItemsResponse';
import {
    FleetSyncItemsResponseFromJSON,
    FleetSyncItemsResponseFromJSONTyped,
    FleetSyncItemsResponseToJSON,
    FleetSyncItemsResponseToJSONTyped,
} from './FleetSyncItemsResponse';

/**
 * 
 * @export
 * @interface FleetSyncResponse
 */
export interface FleetSyncResponse {
    /**
     * 
     * @type {Date}
     * @memberof FleetSyncResponse
     */
    serverTimeUtc?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FleetSyncResponse
     */
    isFullSync?: boolean;
    /**
     * 
     * @type {FleetSyncItemsResponse}
     * @memberof FleetSyncResponse
     */
    syncItems?: FleetSyncItemsResponse;
}

/**
 * Check if a given object implements the FleetSyncResponse interface.
 */
export function instanceOfFleetSyncResponse(value: object): value is FleetSyncResponse {
    return true;
}

export function FleetSyncResponseFromJSON(json: any): FleetSyncResponse {
    return FleetSyncResponseFromJSONTyped(json, false);
}

export function FleetSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimeUtc': json['serverTimeUtc'] == null ? undefined : (new Date(json['serverTimeUtc'])),
        'isFullSync': json['isFullSync'] == null ? undefined : json['isFullSync'],
        'syncItems': json['syncItems'] == null ? undefined : FleetSyncItemsResponseFromJSON(json['syncItems']),
    };
}

export function FleetSyncResponseToJSON(json: any): FleetSyncResponse {
    return FleetSyncResponseToJSONTyped(json, false);
}

export function FleetSyncResponseToJSONTyped(value?: FleetSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimeUtc': value['serverTimeUtc'] == null ? undefined : ((value['serverTimeUtc']).toISOString()),
        'isFullSync': value['isFullSync'],
        'syncItems': FleetSyncItemsResponseToJSON(value['syncItems']),
    };
}

